// extracted by mini-css-extract-plugin
export default {"headerDropdown":"HeaderDropdown__headerDropdown___SPDgx"};